

define(['squid/index', 'text!./template.html', 'components/xo-models/src/checkout/index', 'components/xo-models/src/fi/index', 'components/xo-beaver/dist/logger'], function (squid, template) {

    squid.module('xo-offer.directive', ['squid', 'xomodel.checkout']).directive('xoOffer', function () {
        return {
            template: template,

            scope: {
                token: '=',
                promotion: '=',
                bmlaction: '=',
                installment: '='
            },

            controller: function controller($scope, $FallbackError, $populate, $state, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutCartModel, $pxp, $logger, $InstallmentOptionsModel, $feature, $locale, $CheckoutPayeeModel, $util, $CreditDataModel, $CreditOptionsModel, $config) {

                $populate($scope, {
                    checkoutSession: $CheckoutSessionModel.instance($scope.token),
                    checkoutCart: $CheckoutCartModel.instance($scope.token),
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    payee: $CheckoutPayeeModel.instance($scope.token)
                }).then(function () {
                    $scope.creditTerms = $config.urls.creditTerms;
                    $scope.creditReuseTerms = $config.urls.creditReuseTerms;
                    $scope.bmlOffer = $scope.checkoutSession.bmlOffer;
                    var country = $scope.checkoutAppData.merchant.merchant_country;
                    var cart = $scope.checkoutCart;
                    var isRedirectFromCape = $CreditDataModel.instance($scope.token).isRedirectFromCape();
                    var fundingInstruments = $scope.checkoutSession.get('fundingOptions.instruments');
                    var showExistingPPCBanner = false;
                    $scope.showPPCLogo = false;
                    var merchantId = $scope.payee.getId();
                    var isCreditInWallet = $util.find(fundingInstruments, function (fi) {
                        return fi.type === 'CREDIT';
                    });

                    if ($feature('creditInstallmentOffers') && country === 'US' && !cart.isBilling()) {

                        var offers = $InstallmentOptionsModel.instance($scope.token);
                        offers.save({
                            data: {
                                payee: $scope.payee,
                                checkoutCart: $scope.checkoutCart,
                                checkoutAppData: $scope.checkoutAppData,
                                isMemberCredit: true
                            },
                            success: function success(result) {
                                var installmentOptions = $scope.checkoutSession.creditOffer && result && result.installments && result.installments[0] && result.installments[0].installment_options && result.installments[0].installment_options.length > 0;
                                $scope.installment.showBanner = !isCreditInWallet && installmentOptions && !isRedirectFromCape ? true : false;
                                $scope.installment.showCYCO = installmentOptions ? true : false;
                                $scope.showBml = $scope.installment.showBanner || isRedirectFromCape ? false : $scope.bmlOffer === 1 || $scope.bmlOffer === 2;
                            },
                            contingencies: {
                                DEFAULT: function DEFAULT() {
                                    $logger.info('GET_INSTALLMENT_CONTINGENCY');
                                }
                            }
                        });
                    } else {
                        $scope.showBml = cart.isBillingNoPurchase() || isRedirectFromCape ? false : $scope.bmlOffer === 1 || $scope.bmlOffer === 2;
                    }

                    $scope.selectExistingBml = function () {

                        var fundingSource = $util.find(fundingInstruments, function (fi) {
                            return fi.name === 'BILL_ME_LATER';
                        });

                        $scope.checkoutSession.fundingOptions.action('select', {

                            resultModel: $scope.checkoutSession,

                            data: {
                                planId: fundingSource.planId
                            },
                            success: function success(result) {
                                if (result) {
                                    // Update the installments to support the user selecting a card that does not support installments.
                                    $scope.checkoutSession.installments = result.installments;
                                }
                                if (fundingSource.type === 'CREDIT' && $scope.installment.showCYCO) {
                                    $state.go('checkout.chooseCreditOffer');
                                } else {
                                    if (!fundingSource.selected) {
                                        $scope.checkoutSession.message = {
                                            type: 'success',
                                            msgKeys: ['paymentMethod.paymentMethodUpdated']
                                        };
                                        if ($scope.checkoutSession.selectedInstallmentData && !$scope.checkoutSession.selectedInstallmentData.preventChange) {
                                            // Resetting selected installment data, if installment change is not explicitly prohibited.
                                            $scope.checkoutSession.selectedInstallmentData = undefined;
                                        }
                                    }
                                    $state.go('checkout.review');
                                }
                            }
                        });
                    };

                    var showBmlOfferTreatment = function showBmlOfferTreatment() {
                        var bannerExperiment = 'xo_hermesnodeweb_us_ryi_ppc_ppcreusebanner',
                            noBanner = 'xo_hermesnodeweb_us_ryi_ppc_control',
                            noLogo = 'xo_hermesnodeweb_us_ryi_ppc_nologo',
                            ppcLogo = 'xo_hermesnodeweb_us_ryi_ppc_ppclogo',
                            logo99 = 'xo_hermesnodeweb_us_ryi_ppc_99logo';
                        $scope.pxpCalled = true;
                        return $pxp(bannerExperiment, {
                            'ctx.COUNTRY': $locale.country,
                            'ctx.MERCHANT_ID': merchantId
                        }, '(xo_hermesnodeweb_us_ryi_ppc_)(.*)').then(function (result) {
                            switch (result && result.treatment_name) {
                                case noBanner:
                                    $scope.showPPCLogo = false;
                                    showExistingPPCBanner = false;
                                    break;
                                case noLogo:
                                    showExistingPPCBanner = true;
                                    break;
                                case ppcLogo:
                                    showExistingPPCBanner = true;
                                    $scope.showPPCLogo = true;
                                    break;
                                case logo99:
                                    showExistingPPCBanner = $scope.isBmlOfferSmallOrLarge() === 'offers.bmlExistingOfferLarge';
                                    $scope.showPPCLogo = true;
                                    break;
                                default:
                                    break;
                            }
                        }, function () {
                            $scope.pxpCalled = false;
                        });
                    };

                    /**
                     * Only show PPC Reuse banner if
                     * Country is US & Credit is not default AND There is credit in wallet AND pxp variant has banner
                     **/
                    $scope.showReuseBanner = function () {
                        $scope.isCreditDefault = $scope.checkoutSession.get('plan.paypal_credit');
                        if ($locale.country === 'US' && isCreditInWallet && !$scope.showBml && !$scope.isCreditDefault) {
                            if (!$scope.pxpCalled) {
                                showBmlOfferTreatment();
                            }
                            return showExistingPPCBanner;
                        }
                        return false;
                    };

                    /**
                     * This function is to determine that the offer is large offer (transaction amount >= 99) or
                     * smaller (transaction amount < 99) to display appropriate text on ui
                     * @returns bmlExistingSmall/LargeOffer
                     */
                    $scope.isBmlOfferSmallOrLarge = function () {
                        var transactionAmount = $scope.checkoutCart.get('purchase.amounts.total.amount');
                        if (parseFloat(transactionAmount) >= $CreditOptionsModel.sacEligibleAmount[$locale.country]) {
                            return 'offers.bmlExistingOfferLarge';
                        } else {
                            return 'offers.bmlExistingOfferSmall';
                        }
                    };

                    $scope.bml = function () {
                        $state.go('.applyPPC');
                    };

                    $scope.creditOffer = function () {
                        $state.go('checkout.chooseCreditOffer');
                    };

                    $scope.addPlcc = function () {
                        $scope.promotion.type = 'plcc';
                        $state.go('checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard');
                    };

                    $scope.showPlcc = $scope.checkoutSession.plccOffer;
                });
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-credit-components/src/offer/directive.js
 ** module id = 372
 ** module chunks = 1
 **/